"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaskVisibility = exports.TaskCategory = exports.TaskStatus = exports.TaskType = void 0;
var TaskType;
(function (TaskType) {
    TaskType["HasCustomizedStoreHandle"] = "HAS_CUSTOMIZED_STORE_HANDLE";
    TaskType["HasCustomizedStoreLogo"] = "HAS_CUSTOMIZED_STORE_LOGO";
    TaskType["HasCustomizedStoreBackgroundImage"] = "HAS_CUSTOMIZED_STORE_BANNER";
    TaskType["HasCustomizedStoreName"] = "HAS_CUSTOMIZED_STORE_NAME";
    TaskType["HasCustomizedStoreDescription"] = "HAS_CUSTOMIZED_STORE_DESCRIPTION";
    TaskType["HasCustomizedStorePaymentMethods"] = "HAS_CUSTOMIZED_STORE_PAYMENT_METHODS";
    TaskType["HasCustomizedStoreWhatsAppContact"] = "HAS_CUSTOMIZED_STORE_WHATSAPP_CONTACT";
    TaskType["HasPublishedFirstOffer"] = "HAS_PUBLISHED_FIRST_OFFER";
    TaskType["HasPublishedSecondOffer"] = "HAS_PUBLISHED_SECOND_OFFER";
    TaskType["HasReceivedFirstOrder"] = "HAS_RECEIVED_FIRST_ORDER";
    TaskType["HasAddedStorefrontUrlToInstagram"] = "HAS_ADDED_STOREFRONT_URL_TO_INSTAGRAM";
    /**
     * This task required a store to connect at least a channel.
     */
    TaskType["HasConnectedFirstChannel"] = "HAS_CONNECTED_FIRST_CHANNEL";
    /**
     * Connected Other Channel
     */
    TaskType["HasConnectedSecondChannel"] = "HAS_CONNECTED_SECOND_CHANNEL";
    /**
     * Published product
     */
    TaskType["HasCreatedItem"] = "HAS_CREATED_ITEM";
    /**
     * Async Product
     */
    TaskType["HasSyncedItems"] = "HAS_SYNCED_ITEMS";
    /**
     * First Promotional Art
     */
    TaskType["HasCreatedFirstPromotionalArt"] = "HAS_CREATED_FIRST_PROMOTIONAL_ART";
    /**
     * Completed the catalog configuration
     */
    TaskType["HasBeenOfferedHelpOnCatalogSetup"] = "HAS_BEEN_OFFERED_HELP_ON_CATALOG_SETUP";
    /**
     * Crated or use a category
     */
    TaskType["HasBeenOfferedHelpOnUsingCategory"] = "HAS_BEEN_OFFERED_HELP_ON_USING_CATEGORY";
    /**
     * Store shared catalog
     */
    TaskType["HasBeenOfferedHelpOnShareCatalog"] = "HAS_BEEN_OFFERED_HELP_ON_SHARE_CATALOG";
    /**
     * Received a message about adding a catalog url in Instagram
     */
    TaskType["HasBeenOfferedHelpOnAddingCatalogUrlToInstagram"] = "HAS_BEEN_OFFERED_HELP_ON_ADDING_CATALOG_URL_TO_INSTAGRAM";
    /**
     * Someone accessed the catalog through a QR code
     */
    TaskType["HasBeenOfferedHelpOnPrintingAndShareQRCode"] = "HAS_BEEN_OFFERED_HELP_ON_PRINTING_AND_SHARE_QR_CODE";
    /**
     * Created a promotional art
     */
    TaskType["HasBeenOfferedHelpOnCreatingPromotionalArt"] = "HAS_BEEN_OFFERED_HELP_ON_CREATING_PROMOTIONAL_ART";
    /**
     * Created a promotional
     */
    TaskType["HasBeenOfferedHelpOnCreatingPromotion"] = "HAS_BEEN_OFFERED_HELP_ON_CREATING_PROMOTION";
    /**
     * Created a coupon
     */
    TaskType["HasBeenOfferedHelpOnCreatingCoupon"] = "HAS_BEEN_OFFERED_HELP_ON_CREATING_COUPON";
})(TaskType || (exports.TaskType = TaskType = {}));
var TaskStatus;
(function (TaskStatus) {
    TaskStatus["NotReady"] = "NOT_READY";
    TaskStatus["Pending"] = "PENDING";
    TaskStatus["Completed"] = "COMPLETED";
})(TaskStatus || (exports.TaskStatus = TaskStatus = {}));
var TaskCategory;
(function (TaskCategory) {
    TaskCategory["User"] = "USER";
    TaskCategory["StoreActivation"] = "STORE_ACTIVATION";
})(TaskCategory || (exports.TaskCategory = TaskCategory = {}));
var TaskVisibility;
(function (TaskVisibility) {
    TaskVisibility["Hidden"] = "HIDDEN";
    TaskVisibility["Visible"] = "VISIBLE";
})(TaskVisibility || (exports.TaskVisibility = TaskVisibility = {}));
//# sourceMappingURL=task.js.map